import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "configs";
import { TEXT_STRING } from "./constants";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(TEXT_STRING.ERROR.ROOT_ELEMENT_NOT_FOUND);
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
